import axiosInstance from "shared/axios";
import { CITY_APIS } from "shared/constants";

export const fetchCityList = (param) =>{
    let url = `${CITY_APIS.listing}`
    return axiosInstance.post(url,param)
}
export const createCity = (data) => {
    let url = `${CITY_APIS.create}`;
    return axiosInstance.post(url,data);
};

export const updateCity = (data) => {
    let url = `${CITY_APIS.update}`;
    return axiosInstance.patch(url,data);
};
export const stateDropDwonListt = (param) =>{
    let fullParam = param ? `${CITY_APIS.dropDownState}${param}` : `${CITY_APIS.dropDownState}`;
    return axiosInstance.post(fullParam)
  }